import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import AdminAdCampaigns from "./AdminAdCampaigns";
import AdminPostAds from "./AdminPostAds";
import "../AdminDashboard.css";

// =====================================================
// ADMIN — ADVERTISING MANAGEMENT (its own page, /ads-admin)
//   1. Post an Advertisement — the admin's own Text / Image / Video ads,
//      live in Read Blogs immediately (AdminPostAds).
//   2. Advertiser campaigns — the public "Advertise with us" flow: the same
//      AdminAdCampaigns sections the Admin Dashboard embeds (overview, ad
//      types & pricing, campaigns, reported ads). Opens on "All" campaigns so
//      every new campaign is visible at once; the status filter narrows it.
// =====================================================
function AdminAdvertisingPage() {
  return (
    <div className="admin-root">
      <Navbar />
      <div className="admin-page">
        <div className="admin-hero">
          {/* "Management" is one long word: scaled with the screen so it never overflows on a phone. */}
          <h1 className="admin-title" style={{ fontSize: "clamp(24px, 7.5vw, 42px)", overflowWrap: "anywhere" }}>
            📢 Advertising Management
          </h1>
          <p className="admin-sub">Post your own Text, Image and Video ads to Read Blogs, and manage advertiser campaigns</p>
          <Link
            to="/admin"
            style={{
              display: "inline-block",
              marginTop: "14px",
              padding: "10px 20px",
              borderRadius: "10px",
              background: "rgba(255, 255, 255, 0.08)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            ← Back to Admin Dashboard
          </Link>
        </div>
        <AdminPostAds />

        <div className="admin-hero">
          <h2 className="admin-title" style={{ fontSize: "clamp(20px, 5vw, 28px)" }}>🏢 Advertiser Campaigns</h2>
          <p className="admin-sub">Paid ads submitted by advertisers through “Advertise with us” — review, approve and manage them here.</p>
        </div>
        <AdminAdCampaigns initialStatus="" />
      </div>
    </div>
  );
}

export default AdminAdvertisingPage;
